<template>
    <el-table
        :data="signInTable"
        border
        class="performanceSignInTable"
        :height="320"
    >
        <el-table-column
            label="商品编码"
            prop="itemCode"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="商品名称"
            prop="itemName"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="商品数量"
            prop="qty"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="网点签收正品"
            prop="realReceive"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="网点签收拒收"
            prop="rejectQty"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="用户签收正品"
            prop="receiverRealReceiveCount"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="用户签收拒收"
            prop="receiverRejectQty"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
    </el-table>
</template>
<script>
export default {
    name: 'signInTable',
    data () {
        return {
            signInTable: []
        };
    },
    methods: {
        /**
         * @description 初始化网点配送表格数据
         * @param {Object} data 接口返回的网点配送数据
         */
        initTableData (data) {
            this.signInTable = data;
        }
    }
};
</script>
